export enum UserFeatureCode {
    DataUiWeb = 'data-ui-web',
    WysiwygEditor = 'wysiwyg-editor',
    WikiEditor = 'wiki-editor',
    FastCreate = 'fast-create',
}

export enum UserFeatureSetting {
    'data-ui-web' = 'data_ui_web',
    'wysiwyg-editor' = 'wysiwyg_editor',
    'wiki-editor' = 'wiki_editor',
    'fast-create' = 'fast_create',
}

export enum UserFeatureStatus {
    PendingEnable = 'PENDING_ENABLE',
    Enabled = 'ENABLED',
    PendingDisable = 'PENDING_DISABLE',
    Disabled = 'DISABLED',
}

export interface UserFeature {
    id?: number;
    code: UserFeatureCode;
    status: UserFeatureStatus;
}
